module.exports = __webpack_public_path__ + "static/media/IMG_4875.af6ca809.JPG";